import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    setUserAcceptRules,
    setUserMail,
    setUserPassowrd,
    onBlurMail,
    onBlurPassword,
    register,
} from './registerActions';
import { setCustomer } from '../customerActions';
import Register from './Register';

function RegisterContainer(props) {
    return (
        <Register
            user={props.user}
            error={props.error}
            errorMail={props.errorMail}
            isPending={props.isPending}
            applicationId={props.applicationId}
            customer={props.customer}
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            setUserMail={props.setUserMail}
            setUserPassword={props.setUserPassword}
            setUserAcceptRules={props.setUserAcceptRules}
            onBlurMail={props.onBlurMail}
            onBlurPassword={props.onBlurPassword}
            register={props.register}
            setCustomer={props.setCustomer}
        />
    );
}

const mapStateToProps = state => ({
    user: state.registerReducer.user,
    error: state.registerReducer.error,
    errorMail: state.registerReducer.errorMail,
    isPending: state.registerReducer.isPending,
    applicationId: state.applicationIdReducer,
    customer: state.customerReducer,
});

const mapDispatchToProps = dispatch => ({
    setUserMail: (event) => {
        dispatch(setUserMail(event));
    },
    setUserPassword: (event) => {
        dispatch(setUserPassowrd(event));
    },
    setUserAcceptRules: (event) => {
        dispatch(setUserAcceptRules(event));
    },
    onBlurMail: () => {
        dispatch(onBlurMail());
    },
    onBlurPassword: () => {
        dispatch(onBlurPassword());
    },
    register: data => dispatch(register(data)),
    setCustomer: (uid, mail) => {
        dispatch(setCustomer(uid, mail));
    },
});

RegisterContainer.propTypes = {
    user: PropTypes.object.isRequired,
    error: PropTypes.string.isRequired,
    errorMail: PropTypes.string.isRequired,
    isPending: PropTypes.bool.isRequired,
    applicationId: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setUserMail: PropTypes.func.isRequired,
    setUserPassword: PropTypes.func.isRequired,
    setUserAcceptRules: PropTypes.func.isRequired,
    onBlurMail: PropTypes.func.isRequired,
    onBlurPassword: PropTypes.func.isRequired,
    register: PropTypes.func.isRequired,
    setCustomer: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RegisterContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/Register/RegisterContainer.js